import { render, staticRenderFns } from "./TermsCheckbox.vue?vue&type=template&id=836a63ec&"
import script from "./TermsCheckbox.vue?vue&type=script&lang=ts&"
export * from "./TermsCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./TermsCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports